(function (Drupal, $, once) {
  Drupal.behaviors.menuToggle = {
    attach: function (context) {
      const $region = $('.main-menu'),
      $button = $('.header__toggle-menu');

      $(once('menuToggle', $button)).on('click touch', function() {
        let ariaExpanded = $(this).attr('aria-expanded');
        $('html').toggleClass('show-main-menu');

        if (ariaExpanded === 'true') {
          $(this).attr('aria-expanded', 'false');

          $region.focus();
        } else {
          $(this).attr('aria-expanded', 'true');
        }
      });

      // Listen to keypress
      $(document).on('keydown', function(e) {
        if (e.key === 'Escape') {
          let ariaExpanded = $button.attr('aria-expanded');

          if (ariaExpanded === 'true') {
            $('html').removeClass('show-main-menu');
            $button.attr('aria-expanded', 'false');
          }
        }
      });
    }
  };
}(Drupal, jQuery, once));